
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jHois", function(module, exports) {

var $jIOyV = parcelRequire("jIOyV");


var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");


var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

const $e3adf083a3ceeb07$export$3cf4b7499c49a1bc = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY)
});
const $e3adf083a3ceeb07$export$f38e95ed03e5cac6 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_INTERACTION)
});
const $e3adf083a3ceeb07$export$fe68f7d0c5f4b391 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION)
});
const $e3adf083a3ceeb07$export$f35c906f54c0512a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.PAGE_ANALYTICS_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$aa2d84a67f31f760 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SPACE_ANALYTICS_PAGE_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$73b0f2ef62226204 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SITE_ANALYTICS_LOAD_KEY)
});
module.exports["CONTENT_ANALYTICS_VIEWERS_METRIC"] = $e3adf083a3ceeb07$export$3cf4b7499c49a1bc;
module.exports["CONTENT_ANALYTICS_DIALOG_METRIC"] = $e3adf083a3ceeb07$export$f38e95ed03e5cac6;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_METRIC"] = $e3adf083a3ceeb07$export$fe68f7d0c5f4b391;
module.exports["PAGE_ANALYTICS_PAGE_LOAD_METRIC"] = $e3adf083a3ceeb07$export$f35c906f54c0512a;
module.exports["SPACE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$aa2d84a67f31f760;
module.exports["SITE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$73b0f2ef62226204;

});

parcelRegister("pG0Ei", function(module, exports) {
var $8787696ab5570b52$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["NORMAL"] = "normal";
    AccountType["GUEST"] = "guest";
    AccountType["ANONYMOUS"] = "anonymous";
    return AccountType;
}({});
module.exports["AccountType"] = $8787696ab5570b52$export$b8ca5fa4899cbfc7;

});

parcelRegister("5Rd17", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $2QrXF = parcelRequire("2QrXF");


var $w6R6I = parcelRequire("w6R6I");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $6gGPb = parcelRequire("6gGPb");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $jmjWc = parcelRequire("jmjWc");


var $hjyA9 = parcelRequire("hjyA9");


var $nRoEX = parcelRequire("nRoEX");










const $bba20334be910b9f$export$e23ae35269442b4f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { label: t1, size: t2 } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? 16 : t2;
    const clipId = (0, $cozmU.useId)();
    const t3 = label ? "img" : "presentation";
    const t4 = label || undefined;
    const t5 = label ? undefined : true;
    const t6 = `url(#${clipId})`;
    let t10;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
            fill: "#1868DB"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
            fill: "#6A9A23"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
            fill: "#AF59E1"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
            fill: "#FCA700"
        });
        $[0] = t10;
        $[1] = t7;
        $[2] = t8;
        $[3] = t9;
    } else {
        t10 = $[0];
        t7 = $[1];
        t8 = $[2];
        t9 = $[3];
    }
    let t11;
    if ($[4] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: t6
        }, t7, t8, t9, t10);
        $[4] = t6;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white"
        });
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== clipId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipId
        }, t12));
        $[7] = clipId;
        $[8] = t13;
    } else t13 = $[8];
    let t14;
    if ($[9] !== size || $[10] !== t11 || $[11] !== t13 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: t3,
            "aria-label": t4,
            "aria-hidden": t5
        }, t11, t13);
        $[9] = size;
        $[10] = t11;
        $[11] = t13;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t14;
    } else t14 = $[15];
    return t14;
} : ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};



const $4580118d363597fd$var$CursorIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qxMxj",
    name: "CursorIcon",
    loader: async ()=>(await (parcelRequire("8sEcW"))).CursorIcon
}); /**
     * The Claude, ChatGPT and Figma brand icons only render for the rare
     * `agentIcon === 'claude'` / `'chatgpt'` / `'figma'` cases, so — like the Cursor icon —
     * they are code-split into their own chunks and loaded after paint rather than weighing
     * down every chunk that includes this module.
     */ 

const $4580118d363597fd$var$ClaudeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d5osh",
    name: "ClaudeIcon",
    loader: async ()=>(await (parcelRequire("iXwTo"))).ClaudeIcon
});

const $4580118d363597fd$var$ChatGptIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bqiWP",
    name: "ChatGptIcon",
    loader: async ()=>(await (parcelRequire("4gdcu"))).ChatGptIcon
});

const $4580118d363597fd$var$FigmaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8mOo8",
    name: "FigmaIcon",
    loader: async ()=>(await (parcelRequire("24asi"))).FigmaIcon
}); /**
     * The Dia and Codex icons only render for the rare `agentIcon === 'dia'` / `'codex'`
     * cases, so — like the other brand icons — they are code-split into their own chunks and
     * loaded after paint.
     */ 

const $4580118d363597fd$var$DiaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "00ZJa",
    name: "DiaIcon",
    loader: async ()=>(await (parcelRequire("30hRj"))).DiaIcon
});

const $4580118d363597fd$var$CodexIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fycRd",
    name: "CodexIcon",
    loader: async ()=>(await (parcelRequire("jwYVS"))).CodexIcon
});

const $4580118d363597fd$var$GrokIcon = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "a8DoG",
    name: "GrokIcon",
    loader: async ()=>(await (parcelRequire("3Jxmn"))).GrokIcon
});

const $4580118d363597fd$var$GitHubCopilotIcon = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "alApy",
    name: "GitHubCopilotIcon",
    loader: async ()=>(await (parcelRequire("2fpBI"))).GitHubCopilotIcon
});

const $4580118d363597fd$var$VisualStudioCodeIcon = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mRgOx",
    name: "VisualStudioCodeIcon",
    loader: async ()=>(await (parcelRequire("1np84"))).VisualStudioCodeIcon
});

const $4580118d363597fd$var$OpenCodeIcon = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "pJYHQ",
    name: "OpenCodeIcon",
    loader: async ()=>(await (parcelRequire("3uVyX"))).OpenCodeIcon
});

const $4580118d363597fd$var$HermesAgentIcon = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "kDjrA",
    name: "HermesAgentIcon",
    loader: async ()=>(await (parcelRequire("coVO2"))).HermesAgentIcon
});

const $4580118d363597fd$var$KiroIcon = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lt434",
    name: "KiroIcon",
    loader: async ()=>(await (parcelRequire("au1T9"))).KiroIcon
}); /**
     * Row-model mixin for tables that render AI-agent activity rows. Intersect it into a
     * table's own row data model. All fields are optional so existing (people) rows are
     * unaffected. Shared across the Page viewers table and the Space/Site users activity
     * tables.
     */ 
const $4580118d363597fd$export$8f1cb3c7f8edc6be = (0, $kSwu1.defineMessages)({
    expandAgentRow: {
        id: "confluence-analytics.agent-activity.expand-agent-row",
        defaultMessage: "Show the people who used this agent"
    },
    collapseAgentRow: {
        id: "confluence-analytics.agent-activity.collapse-agent-row",
        defaultMessage: "Hide the people who used this agent"
    },
    agentSubtitle: {
        id: "confluence-analytics.agent-activity.agent-subtitle",
        defaultMessage: "with {name}{count, plural, =0 {} one { and # other} other { and # others}}"
    }
});
const $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE = 'small';
const $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_USER_SIZE = 'xxsmall';
const $4580118d363597fd$var$unidentifiedAgentAvatarBackgroundStyles = null;
const $4580118d363597fd$var$DEFAULT_AVATAR_ITEM_COVER = {
    top: 0,
    left: 0,
    width: 32,
    height: 32
};
const $4580118d363597fd$var$dualAvatarCardTriggerStyles = null;
const $4580118d363597fd$var$useAvatarItemCover = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const rootRef = (0, $cozmU.useRef)(null);
    const [cover, setCover] = (0, $cozmU.useState)($4580118d363597fd$var$DEFAULT_AVATAR_ITEM_COVER);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const root = rootRef.current;
            const identityCell = root?.parentElement;
            if (!root || !identityCell) return;
            const updateCover = ()=>{
                const identityRect = identityCell.getBoundingClientRect();
                const rootRect = root.getBoundingClientRect();
                if (identityRect.width === 0 && identityRect.height === 0) return;
                setCover({
                    top: identityRect.top - rootRect.top,
                    left: identityRect.left - rootRect.left,
                    width: identityRect.width,
                    height: identityRect.height
                });
            };
            updateCover();
            if (typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(updateCover);
            observer.observe(identityCell);
            observer.observe(root);
            return ()=>observer.disconnect();
        };
        t1 = [
            rootRef
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    let t2;
    if ($[2] !== cover) {
        t2 = {
            rootRef: rootRef,
            cover: cover
        };
        $[2] = cover;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const rootRef = (0, $cozmU.useRef)(null);
    const [cover, setCover] = (0, $cozmU.useState)($4580118d363597fd$var$DEFAULT_AVATAR_ITEM_COVER);
    (0, $cozmU.useLayoutEffect)(()=>{
        const root = rootRef.current;
        const identityCell = root?.parentElement;
        if (!root || !identityCell) return;
        const updateCover = ()=>{
            const identityRect = identityCell.getBoundingClientRect();
            const rootRect = root.getBoundingClientRect();
            if (identityRect.width === 0 && identityRect.height === 0) return;
            setCover({
                top: identityRect.top - rootRect.top,
                left: identityRect.left - rootRect.left,
                width: identityRect.width,
                height: identityRect.height
            });
        };
        updateCover();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(updateCover);
        observer.observe(identityCell);
        observer.observe(root);
        return ()=>observer.disconnect();
    }, [
        rootRef
    ]);
    return {
        rootRef: rootRef,
        cover: cover
    };
};
const $4580118d363597fd$var$styles = {
    toggleSmall: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _24h04i2Njc _0GTcwRFQfX _2xTnZxFQfX _0KLXru66of",
    toggleMedium: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _24h04i2Njc _2xTnZxFQfX _0KLXru66of",
    childIndent: "_0LQT5ES40j",
    iconWrapperSmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX",
    iconWrapperMedium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    iconWrapperSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    iconWrapperMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC",
    unidentifiedAgentAvatarSmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarMedium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _1uo2ZfTcEg",
    unidentifiedAgentAvatarMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1uo2ZfTcEg",
    brandAgentTile: "_1uo2ZfTcEg _0KLXruDMqu",
    avatarOffsetInlineStart: "_1VJPcac8DQ",
    dualAvatar: "_1mT5xdRAKS _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    dualAvatarOffsetInlineStart: "_1mT5xdRAKS _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1VJPcac8DQ",
    dualAvatarAgent: "_1mT5xdWVPG _2IhTonPgdg _3iC0zdPgdg _39xV02SPN1 _0jFU0VSPN1 _1VJPca4XqE _0yKXXaXmhc",
    dualAvatarUser: "_0bjKvDS5Zs _1mT5xdWVPG _2IhTon8HPE _1OKFqYFQfX _43nrzTFQfX _0KLXrulfZc",
    dualAvatarTriggerFill: "_1mT5xdRAKS _39xV02N91d _0jFU0VN91d _3iDTPbvLZJ _1pp6NdYbGa",
    dualAvatarVisualStack: "_1mT5xdWVPG _39xV02Uofl _0jFU0VUofl _1pp6NdYbGa",
    dualAvatarTriggerTarget: "_1pp6NdIZbP"
};
const $4580118d363597fd$var$AgentAvatarContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children } = t0;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4580118d363597fd$var$styles.iconWrapperMedium
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (avatarSize === "medium") {
        let t1;
        if ($[2] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4580118d363597fd$var$styles.iconWrapperMediumNoSpacing
            }, children);
            $[2] = children;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    if (hasInlineSpacing) {
        let t1;
        if ($[4] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4580118d363597fd$var$styles.iconWrapperSmall
            }, children);
            $[4] = children;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    let t1;
    if ($[6] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4580118d363597fd$var$styles.iconWrapperSmallNoSpacing
        }, children);
        $[6] = children;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children })=>{
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperMedium
    }, children);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperMediumNoSpacing
    }, children);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperSmall
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperSmallNoSpacing
    }, children);
};
const $4580118d363597fd$var$UnidentifiedAgentAvatar = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2yBoao1qiM"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = avatarSize === "medium" ? "medium" : "small";
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "unidentified-agent-avatar-background",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: t2
        }));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const icon = t3;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t4;
        if ($[3] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMedium
            }, icon);
            $[3] = icon;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    if (avatarSize === "medium") {
        let t4;
        if ($[5] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMediumNoSpacing
            }, icon);
            $[5] = icon;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    if (hasInlineSpacing) {
        let t4;
        if ($[7] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmall
            }, icon);
            $[7] = icon;
            $[8] = t4;
        } else t4 = $[8];
        return t4;
    }
    let t4;
    if ($[9] !== icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "unidentified-agent-avatar",
            xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmallNoSpacing
        }, icon);
        $[9] = icon;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing })=>{
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "unidentified-agent-avatar-background",
        className: (0, $hekY6.default)([
            "_2yBoao1qiM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        label: "",
        appearance: "gray",
        size: avatarSize === 'medium' ? 'medium' : 'small'
    }));
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMedium
    }, icon);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMediumNoSpacing
    }, icon);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmall
    }, icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmallNoSpacing
    }, icon);
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise the deterministic hexagon AgentAvatar
    * (or, when the resolved agent account has a `picture`, that avatar image inside the
    * hexagon).
    */ 
const $4580118d363597fd$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(99);
    const { name: name, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: t1, isOffsetInlineStart: t2, hasInlineSpacing: t3 } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const hasInlineSpacing = t3 === undefined ? true : t3;
    let t4;
    bb0: {
        if (agentIcon === "ai-agent") {
            let t5;
            if ($[0] !== avatarSize || $[1] !== hasInlineSpacing) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$UnidentifiedAgentAvatar, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                });
                $[0] = avatarSize;
                $[1] = hasInlineSpacing;
                $[2] = t5;
            } else t5 = $[2];
            t4 = t5;
            break bb0;
        }
        if (agentIcon === "rovo") {
            const t5 = avatarSize === "medium" ? 32 : 24;
            let t6;
            if ($[3] !== t5) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba20334be910b9f$export$e23ae35269442b4f), {
                    label: "",
                    size: t5
                });
                $[3] = t5;
                $[4] = t6;
            } else t6 = $[4];
            let t7;
            if ($[5] !== avatarSize || $[6] !== hasInlineSpacing || $[7] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t6);
                $[5] = avatarSize;
                $[6] = hasInlineSpacing;
                $[7] = t6;
                $[8] = t7;
            } else t7 = $[8];
            t4 = t7;
            break bb0;
        }
        if (agentIcon === "cursor") {
            const t5 = avatarSize === "medium" ? 32 : 24;
            let t6;
            if ($[9] !== t5) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$CursorIcon, {
                    label: "",
                    size: t5
                });
                $[9] = t5;
                $[10] = t6;
            } else t6 = $[10];
            let t7;
            if ($[11] !== avatarSize || $[12] !== hasInlineSpacing || $[13] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t6);
                $[11] = avatarSize;
                $[12] = hasInlineSpacing;
                $[13] = t6;
                $[14] = t7;
            } else t7 = $[14];
            t4 = t7;
            break bb0;
        }
        if (agentIcon === "claude") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            const t6 = avatarSize === "medium" ? 32 : 24;
            let t7;
            if ($[15] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$ClaudeIcon, {
                    label: "",
                    size: t6
                });
                $[15] = t6;
                $[16] = t7;
            } else t7 = $[16];
            let t8;
            if ($[17] !== t5 || $[18] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t5
                }, t7);
                $[17] = t5;
                $[18] = t7;
                $[19] = t8;
            } else t8 = $[19];
            t4 = t8;
            break bb0;
        }
        if (agentIcon === "chatgpt") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            const t6 = avatarSize === "medium" ? 32 : 24;
            let t7;
            if ($[20] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$ChatGptIcon, {
                    label: "",
                    size: t6
                });
                $[20] = t6;
                $[21] = t7;
            } else t7 = $[21];
            let t8;
            if ($[22] !== t5 || $[23] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t5
                }, t7);
                $[22] = t5;
                $[23] = t7;
                $[24] = t8;
            } else t8 = $[24];
            t4 = t8;
            break bb0;
        }
        if (agentIcon === "figma") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[25] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[25] = t5;
                $[26] = t6;
            } else t6 = $[26];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[27] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$FigmaIcon, {
                    label: "",
                    size: t7
                });
                $[27] = t7;
                $[28] = t8;
            } else t8 = $[28];
            let t9;
            if ($[29] !== t6 || $[30] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[29] = t6;
                $[30] = t8;
                $[31] = t9;
            } else t9 = $[31];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "dia") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[32] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[32] = t5;
                $[33] = t6;
            } else t6 = $[33];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[34] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$DiaIcon, {
                    label: "",
                    size: t7
                });
                $[34] = t7;
                $[35] = t8;
            } else t8 = $[35];
            let t9;
            if ($[36] !== t6 || $[37] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[36] = t6;
                $[37] = t8;
                $[38] = t9;
            } else t9 = $[38];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "codex") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[39] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[39] = t5;
                $[40] = t6;
            } else t6 = $[40];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[41] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$CodexIcon, {
                    label: "",
                    size: t7
                });
                $[41] = t7;
                $[42] = t8;
            } else t8 = $[42];
            let t9;
            if ($[43] !== t6 || $[44] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[43] = t6;
                $[44] = t8;
                $[45] = t9;
            } else t9 = $[45];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "grok") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[46] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[46] = t5;
                $[47] = t6;
            } else t6 = $[47];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[48] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$GrokIcon, {
                    label: "",
                    size: t7
                });
                $[48] = t7;
                $[49] = t8;
            } else t8 = $[49];
            let t9;
            if ($[50] !== t6 || $[51] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[50] = t6;
                $[51] = t8;
                $[52] = t9;
            } else t9 = $[52];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "github-copilot") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[53] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[53] = t5;
                $[54] = t6;
            } else t6 = $[54];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[55] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$GitHubCopilotIcon, {
                    label: "",
                    size: t7
                });
                $[55] = t7;
                $[56] = t8;
            } else t8 = $[56];
            let t9;
            if ($[57] !== t6 || $[58] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[57] = t6;
                $[58] = t8;
                $[59] = t9;
            } else t9 = $[59];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "vscode") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[60] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[60] = t5;
                $[61] = t6;
            } else t6 = $[61];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[62] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$VisualStudioCodeIcon, {
                    label: "",
                    size: t7
                });
                $[62] = t7;
                $[63] = t8;
            } else t8 = $[63];
            let t9;
            if ($[64] !== t6 || $[65] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[64] = t6;
                $[65] = t8;
                $[66] = t9;
            } else t9 = $[66];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "open-code") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[67] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[67] = t5;
                $[68] = t6;
            } else t6 = $[68];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[69] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$OpenCodeIcon, {
                    label: "",
                    size: t7
                });
                $[69] = t7;
                $[70] = t8;
            } else t8 = $[70];
            let t9;
            if ($[71] !== t6 || $[72] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[71] = t6;
                $[72] = t8;
                $[73] = t9;
            } else t9 = $[73];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "hermes") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[74] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[74] = t5;
                $[75] = t6;
            } else t6 = $[75];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[76] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$HermesAgentIcon, {
                    label: "",
                    size: t7
                });
                $[76] = t7;
                $[77] = t8;
            } else t8 = $[77];
            let t9;
            if ($[78] !== t6 || $[79] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[78] = t6;
                $[79] = t8;
                $[80] = t9;
            } else t9 = $[80];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "kiro") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[81] !== t5) {
                t6 = (0, $w6R6I.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[81] = t5;
                $[82] = t6;
            } else t6 = $[82];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[83] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$KiroIcon, {
                    label: "",
                    size: t7
                });
                $[83] = t7;
                $[84] = t8;
            } else t8 = $[84];
            let t9;
            if ($[85] !== t6 || $[86] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t6
                }, t8);
                $[85] = t6;
                $[86] = t8;
                $[87] = t9;
            } else t9 = $[87];
            t4 = t9;
            break bb0;
        }
        let t5;
        if ($[88] !== avatarSize || $[89] !== avatarUrl || $[90] !== name) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                size: avatarSize,
                name: name,
                label: "",
                imageUrl: avatarUrl
            });
            $[88] = avatarSize;
            $[89] = avatarUrl;
            $[90] = name;
            $[91] = t5;
        } else t5 = $[91];
        let t6;
        if ($[92] !== avatarSize || $[93] !== hasInlineSpacing || $[94] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, t5);
            $[92] = avatarSize;
            $[93] = hasInlineSpacing;
            $[94] = t5;
            $[95] = t6;
        } else t6 = $[95];
        t4 = t6;
    }
    const avatar = t4;
    let t5;
    if ($[96] !== avatar || $[97] !== isOffsetInlineStart) {
        t5 = isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-avatar-offset",
            xcss: $4580118d363597fd$var$styles.avatarOffsetInlineStart
        }, avatar) : avatar;
        $[96] = avatar;
        $[97] = isOffsetInlineStart;
        $[98] = t5;
    } else t5 = $[98];
    return t5;
} : ({ name: name, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', isOffsetInlineStart: isOffsetInlineStart = false, hasInlineSpacing: hasInlineSpacing = true })=>{
    const avatar = (()=>{
        if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$UnidentifiedAgentAvatar, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        });
        if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba20334be910b9f$export$e23ae35269442b4f), {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'cursor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$CursorIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'claude') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$ClaudeIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'chatgpt') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$ChatGptIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'figma') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$FigmaIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'dia') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$DiaIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'codex') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$CodexIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'grok') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$GrokIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'github-copilot') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$GitHubCopilotIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'vscode') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$VisualStudioCodeIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'open-code') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$OpenCodeIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'hermes') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$HermesAgentIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'kiro') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$KiroIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            size: avatarSize,
            name: name,
            label: "",
            imageUrl: avatarUrl
        }));
    })();
    return isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-avatar-offset",
        xcss: $4580118d363597fd$var$styles.avatarOffsetInlineStart
    }, avatar) : avatar;
}; /** Agent avatar anchored top-left, overlapped by the related person's avatar bottom-right. */ 
const $4580118d363597fd$export$524e3ea25887b088 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { agentName: agentName, agentIcon: agentIcon, agentAvatarUrl: agentAvatarUrl, agentUserId: agentUserId, userName: userName, userAvatarUrl: userAvatarUrl, relatedUserId: relatedUserId, isOffsetInlineStart: t1 } = t0;
    const isOffsetInlineStart = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== agentAvatarUrl || $[1] !== agentIcon || $[2] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: agentName,
            agentIcon: agentIcon,
            avatarUrl: agentAvatarUrl,
            avatarSize: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE,
            hasInlineSpacing: false
        });
        $[0] = agentAvatarUrl;
        $[1] = agentIcon;
        $[2] = agentName;
        $[3] = t2;
    } else t2 = $[3];
    const agentAvatar = t2;
    let t3;
    if ($[4] !== userAvatarUrl || $[5] !== userName) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: userAvatarUrl,
            name: userName,
            size: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_USER_SIZE,
            borderColor: "transparent",
            label: ""
        });
        $[4] = userAvatarUrl;
        $[5] = userName;
        $[6] = t3;
    } else t3 = $[6];
    const userAvatar = t3;
    let t4;
    if ($[7] !== agentAvatar || $[8] !== agentName || $[9] !== agentUserId || $[10] !== isOffsetInlineStart || $[11] !== relatedUserId || $[12] !== userAvatar || $[13] !== userName) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$DualAvatarWithIdentityCards, {
            agentName: agentName,
            agentUserId: agentUserId,
            userName: userName,
            relatedUserId: relatedUserId,
            isOffsetInlineStart: isOffsetInlineStart,
            agentAvatar: agentAvatar,
            userAvatar: userAvatar
        });
        $[7] = agentAvatar;
        $[8] = agentName;
        $[9] = agentUserId;
        $[10] = isOffsetInlineStart;
        $[11] = relatedUserId;
        $[12] = userAvatar;
        $[13] = userName;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ agentName: agentName, agentIcon: agentIcon, agentAvatarUrl: agentAvatarUrl, agentUserId: agentUserId, userName: userName, userAvatarUrl: userAvatarUrl, relatedUserId: relatedUserId, isOffsetInlineStart: isOffsetInlineStart = false })=>{
    const agentAvatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: agentName,
        agentIcon: agentIcon,
        avatarUrl: agentAvatarUrl,
        avatarSize: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE,
        hasInlineSpacing: false
    });
    const userAvatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: userAvatarUrl,
        name: userName,
        size: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_USER_SIZE,
        borderColor: "transparent",
        label: ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$var$DualAvatarWithIdentityCards, {
        agentName: agentName,
        agentUserId: agentUserId,
        userName: userName,
        relatedUserId: relatedUserId,
        isOffsetInlineStart: isOffsetInlineStart,
        agentAvatar: agentAvatar,
        userAvatar: userAvatar
    });
};
const $4580118d363597fd$var$DualAvatarWithIdentityCards = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { agentName: agentName, agentUserId: agentUserId, userName: userName, relatedUserId: relatedUserId, isOffsetInlineStart: isOffsetInlineStart, agentAvatar: agentAvatar, userAvatar: userAvatar } = t0;
    const { rootRef: rootRef, cover: cover } = $4580118d363597fd$var$useAvatarItemCover();
    let t1;
    if ($[0] !== cover.height || $[1] !== cover.left || $[2] !== cover.top || $[3] !== cover.width) {
        t1 = {
            top: cover.top,
            left: cover.left,
            width: cover.width,
            height: cover.height
        };
        $[0] = cover.height;
        $[1] = cover.left;
        $[2] = cover.top;
        $[3] = cover.width;
        $[4] = t1;
    } else t1 = $[4];
    const coverStyle = t1;
    const t2 = -cover.top;
    const t3 = -cover.left;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            top: t2,
            left: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const visualStackStyle = t4;
    const t5 = isOffsetInlineStart ? $4580118d363597fd$var$styles.dualAvatarOffsetInlineStart : $4580118d363597fd$var$styles.dualAvatar;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            "data-analytics-card-anchor": "avatar-item"
        };
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {};
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            "data-analytics-card-fill": "avatar-item",
            "data-analytics-card-pointer": "none"
        };
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $w6R6I.cx)($4580118d363597fd$var$styles.dualAvatarAgent, $4580118d363597fd$var$styles.dualAvatarTriggerTarget);
        t11 = {
            "data-analytics-card-pointer": "auto"
        };
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    let t12;
    if ($[14] !== agentAvatar) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-agent-target",
            xcss: t10,
            ...t11
        }, agentAvatar);
        $[14] = agentAvatar;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== visualStackStyle) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-agent-trigger",
            xcss: $4580118d363597fd$var$styles.dualAvatarTriggerFill,
            ...t9
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4580118d363597fd$var$styles.dualAvatarVisualStack,
            style: visualStackStyle
        }, t12));
        $[16] = t12;
        $[17] = visualStackStyle;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== agentName || $[20] !== agentUserId || $[21] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $nRoEX.AnalyticsProfileIdentity), {
            userId: agentUserId,
            fullName: agentName,
            agent: t8
        }, t13);
        $[19] = agentName;
        $[20] = agentUserId;
        $[21] = t13;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== coverStyle || $[24] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "agent-user-dual-avatar-agent-anchor",
            "data-analytics-card-anchor": "avatar-item",
            style: coverStyle,
            className: t7
        }, t14);
        $[23] = coverStyle;
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ]);
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = {
            "data-analytics-card-fill": "avatar-item",
            "data-analytics-card-pointer": "none"
        };
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    let t19;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = (0, $w6R6I.cx)($4580118d363597fd$var$styles.dualAvatarUser, $4580118d363597fd$var$styles.dualAvatarTriggerTarget);
        t19 = {
            "data-analytics-card-pointer": "auto"
        };
        $[28] = t18;
        $[29] = t19;
    } else {
        t18 = $[28];
        t19 = $[29];
    }
    let t20;
    if ($[30] !== userAvatar) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-user-target",
            xcss: t18,
            ...t19
        }, userAvatar);
        $[30] = userAvatar;
        $[31] = t20;
    } else t20 = $[31];
    let t21;
    if ($[32] !== t20 || $[33] !== visualStackStyle) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-user-trigger",
            xcss: $4580118d363597fd$var$styles.dualAvatarTriggerFill,
            ...t17
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4580118d363597fd$var$styles.dualAvatarVisualStack,
            style: visualStackStyle
        }, t20));
        $[32] = t20;
        $[33] = visualStackStyle;
        $[34] = t21;
    } else t21 = $[34];
    let t22;
    if ($[35] !== relatedUserId || $[36] !== t21 || $[37] !== userName) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $nRoEX.AnalyticsProfileIdentity), {
            userId: relatedUserId,
            fullName: userName
        }, t21);
        $[35] = relatedUserId;
        $[36] = t21;
        $[37] = userName;
        $[38] = t22;
    } else t22 = $[38];
    let t23;
    if ($[39] !== coverStyle || $[40] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "agent-user-dual-avatar-user-anchor",
            "data-analytics-card-anchor": "avatar-item",
            style: coverStyle,
            className: t16
        }, t22);
        $[39] = coverStyle;
        $[40] = t22;
        $[41] = t23;
    } else t23 = $[41];
    let t24;
    if ($[42] !== rootRef || $[43] !== t15 || $[44] !== t23 || $[45] !== t5) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: rootRef,
            testId: "agent-user-dual-avatar",
            xcss: t5,
            ...t6
        }, t15, t23);
        $[42] = rootRef;
        $[43] = t15;
        $[44] = t23;
        $[45] = t5;
        $[46] = t24;
    } else t24 = $[46];
    return t24;
} : ({ agentName: agentName, agentUserId: agentUserId, userName: userName, relatedUserId: relatedUserId, isOffsetInlineStart: isOffsetInlineStart, agentAvatar: agentAvatar, userAvatar: userAvatar })=>{
    const { rootRef: rootRef, cover: cover } = $4580118d363597fd$var$useAvatarItemCover();
    const coverStyle = {
        top: cover.top,
        left: cover.left,
        width: cover.width,
        height: cover.height
    };
    const visualStackStyle = {
        top: -cover.top,
        left: -cover.left
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: rootRef,
        testId: "agent-user-dual-avatar",
        xcss: isOffsetInlineStart ? $4580118d363597fd$var$styles.dualAvatarOffsetInlineStart : $4580118d363597fd$var$styles.dualAvatar,
        'data-analytics-card-anchor': 'avatar-item'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "agent-user-dual-avatar-agent-anchor",
        "data-analytics-card-anchor": "avatar-item",
        style: coverStyle,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $nRoEX.AnalyticsProfileIdentity), {
        userId: agentUserId,
        fullName: agentName,
        agent: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-agent-trigger",
        xcss: $4580118d363597fd$var$styles.dualAvatarTriggerFill,
        'data-analytics-card-fill': 'avatar-item',
        'data-analytics-card-pointer': 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.dualAvatarVisualStack,
        style: visualStackStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-agent-target",
        xcss: (0, $w6R6I.cx)($4580118d363597fd$var$styles.dualAvatarAgent, $4580118d363597fd$var$styles.dualAvatarTriggerTarget),
        'data-analytics-card-pointer': 'auto'
    }, agentAvatar))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "agent-user-dual-avatar-user-anchor",
        "data-analytics-card-anchor": "avatar-item",
        style: coverStyle,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $nRoEX.AnalyticsProfileIdentity), {
        userId: relatedUserId,
        fullName: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-user-trigger",
        xcss: $4580118d363597fd$var$styles.dualAvatarTriggerFill,
        'data-analytics-card-fill': 'avatar-item',
        'data-analytics-card-pointer': 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.dualAvatarVisualStack,
        style: visualStackStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-user-target",
        xcss: (0, $w6R6I.cx)($4580118d363597fd$var$styles.dualAvatarUser, $4580118d363597fd$var$styles.dualAvatarTriggerTarget),
        'data-analytics-card-pointer': 'auto'
    }, userAvatar))))));
}; /**
    * The agent's hexagon avatar doubles as the expand affordance: on hover or keyboard
    * focus it swaps to a chevron, and clicking it toggles the nested child rows. Keeping
    * the toggle on the avatar itself (rather than a separate inline control) matches the
    * design.
    */ 
const $4580118d363597fd$export$f483be08076d9dad = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { name: name, isExpanded: isExpanded, onToggle: onToggle, expandLabel: expandLabel, collapseLabel: collapseLabel, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: t1, isOffsetInlineStart: t2 } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const showChevron = isActive || isExpanded;
    const t3 = avatarSize === "medium" ? $4580118d363597fd$var$styles.toggleMedium : $4580118d363597fd$var$styles.toggleSmall;
    const t4 = isExpanded ? collapseLabel : expandLabel;
    let t5;
    if ($[0] !== onToggle) {
        t5 = (event)=>{
            event.stopPropagation();
            onToggle();
        };
        $[0] = onToggle;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsActive(true);
        t7 = ()=>setIsActive(false);
        t8 = ()=>setIsActive(true);
        t9 = ()=>setIsActive(false);
        $[2] = t6;
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
    } else {
        t6 = $[2];
        t7 = $[3];
        t8 = $[4];
        t9 = $[5];
    }
    let t10;
    if ($[6] !== agentIcon || $[7] !== avatarSize || $[8] !== avatarUrl || $[9] !== isExpanded || $[10] !== isOffsetInlineStart || $[11] !== name || $[12] !== showChevron) {
        t10 = showChevron ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: name,
            agentIcon: agentIcon,
            avatarUrl: avatarUrl,
            avatarSize: avatarSize,
            isOffsetInlineStart: isOffsetInlineStart
        });
        $[6] = agentIcon;
        $[7] = avatarSize;
        $[8] = avatarUrl;
        $[9] = isExpanded;
        $[10] = isOffsetInlineStart;
        $[11] = name;
        $[12] = showChevron;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== isExpanded || $[15] !== t10 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: t3,
            "aria-label": t4,
            "aria-expanded": isExpanded,
            onClick: t5,
            onMouseEnter: t6,
            onMouseLeave: t7,
            onFocus: t8,
            onBlur: t9
        }, t10);
        $[14] = isExpanded;
        $[15] = t10;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t11;
    } else t11 = $[19];
    return t11;
} : ({ name: name, isExpanded: isExpanded, onToggle: onToggle, expandLabel: expandLabel, collapseLabel: collapseLabel, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', isOffsetInlineStart: isOffsetInlineStart = false })=>{
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const showChevron = isActive || isExpanded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: avatarSize === 'medium' ? $4580118d363597fd$var$styles.toggleMedium : $4580118d363597fd$var$styles.toggleSmall,
        "aria-label": isExpanded ? collapseLabel : expandLabel,
        "aria-expanded": isExpanded,
        onClick: (event)=>{
            event.stopPropagation();
            onToggle();
        },
        onMouseEnter: ()=>setIsActive(true),
        onMouseLeave: ()=>setIsActive(false),
        onFocus: ()=>setIsActive(true),
        onBlur: ()=>setIsActive(false)
    }, showChevron ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: name,
        agentIcon: agentIcon,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        isOffsetInlineStart: isOffsetInlineStart
    }));
}; /**
    * Renders the name-column cell for an AI-agent row: the hexagon AgentAvatar (which
    * doubles as an expand toggle when the agent has child rows) plus an optional subtitle.
    * The consuming table supplies `name`/`subtitle` from its own row model.
    */ 
const $4580118d363597fd$export$6bb3a1031846604c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { name: name, subtitle: subtitle, isExpandable: isExpandable, isExpanded: isExpanded, onToggleExpand: onToggleExpand, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: t1, isOffsetInlineStart: t2 } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== agentIcon || $[1] !== avatarSize || $[2] !== avatarUrl || $[3] !== formatMessage || $[4] !== isExpandable || $[5] !== isExpanded || $[6] !== isOffsetInlineStart || $[7] !== name || $[8] !== onToggleExpand) {
        t3 = isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$f483be08076d9dad, {
            name: name,
            isExpanded: Boolean(isExpanded),
            onToggle: onToggleExpand,
            expandLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.expandAgentRow),
            collapseLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.collapseAgentRow),
            agentIcon: agentIcon,
            avatarUrl: avatarUrl,
            avatarSize: avatarSize,
            isOffsetInlineStart: isOffsetInlineStart
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: name,
            agentIcon: agentIcon,
            avatarUrl: avatarUrl,
            avatarSize: avatarSize,
            isOffsetInlineStart: isOffsetInlineStart
        });
        $[0] = agentIcon;
        $[1] = avatarSize;
        $[2] = avatarUrl;
        $[3] = formatMessage;
        $[4] = isExpandable;
        $[5] = isExpanded;
        $[6] = isOffsetInlineStart;
        $[7] = name;
        $[8] = onToggleExpand;
        $[9] = t3;
    } else t3 = $[9];
    const avatar = t3;
    let t4;
    if ($[10] !== avatar || $[11] !== name || $[12] !== subtitle) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2QrXF.default), {
            avatar: avatar,
            primaryText: name,
            secondaryText: subtitle
        });
        $[10] = avatar;
        $[11] = name;
        $[12] = subtitle;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ name: name, subtitle: subtitle, isExpandable: isExpandable, isExpanded: isExpanded, onToggleExpand: onToggleExpand, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', isOffsetInlineStart: isOffsetInlineStart = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const avatar = isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$f483be08076d9dad, {
        name: name,
        isExpanded: Boolean(isExpanded),
        onToggle: onToggleExpand,
        expandLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.expandAgentRow),
        collapseLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.collapseAgentRow),
        agentIcon: agentIcon,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        isOffsetInlineStart: isOffsetInlineStart
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: name,
        agentIcon: agentIcon,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        isOffsetInlineStart: isOffsetInlineStart
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2QrXF.default), {
        avatar: avatar,
        primaryText: name,
        secondaryText: subtitle
    });
}; /** Wraps an agent's nested child (person) cell with a left indent. */ 
const $4580118d363597fd$export$bf2de6dc20683668 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4580118d363597fd$var$styles.childIndent
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4580118d363597fd$var$styles.childIndent
    }, children); /**
                                                                           * Owns expand/collapse state and flattens parent rows into the array handed to the
                                                                           * table: each expanded agent's children are spliced directly beneath it, so sorting
                                                                           * and pagination (done by the caller) only ever act on the parent rows.
                                                                           *
                                                                           * When `sorting` is provided, an expanded agent's child (related-user) rows are sorted
                                                                           * by the same column/direction the table is sorted by, so the nested rows stay
                                                                           * consistent with the parent ordering.
                                                                           */ 
const $4580118d363597fd$export$3083e75456a22336 = (0, $3u0dr.isReactCompilerActiveV2)() ? (parentRows, childrenByAgentId, sorting)=>{
    const $ = (0, $bDgLe.c)(6);
    const [expandedAgentIds, setExpandedAgentIds] = (0, $cozmU.useState)($4580118d363597fd$var$_temp);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (agentId)=>{
            setExpandedAgentIds((previous)=>{
                const next = new Set(previous);
                if (next.has(agentId)) next.delete(agentId);
                else next.add(agentId);
                return next;
            });
        };
        $[0] = t0;
    } else t0 = $[0];
    const toggleAgentExpansion = t0;
    let rows;
    if ($[1] !== childrenByAgentId || $[2] !== expandedAgentIds || $[3] !== parentRows || $[4] !== sorting) {
        rows = [];
        parentRows.forEach((row)=>{
            const { isAgent: isAgent, isExpandable: isExpandable, agentId: agentId_0 } = row.data;
            if (isAgent && isExpandable && agentId_0) {
                const isExpanded = expandedAgentIds.has(agentId_0);
                rows.push({
                    ...row,
                    data: {
                        ...row.data,
                        isExpanded: isExpanded,
                        onToggleExpand: ()=>toggleAgentExpansion(agentId_0)
                    }
                });
                if (isExpanded) {
                    const children = childrenByAgentId[agentId_0] ?? [];
                    rows.push(...sorting ? [
                        ...children
                    ].sort((0, $hjyA9.sortByState)(sorting)) : children);
                }
            } else rows.push(row);
        });
        $[1] = childrenByAgentId;
        $[2] = expandedAgentIds;
        $[3] = parentRows;
        $[4] = sorting;
        $[5] = rows;
    } else rows = $[5];
    return rows;
} : (parentRows, childrenByAgentId, sorting)=>{
    const [expandedAgentIds, setExpandedAgentIds] = (0, $cozmU.useState)(()=>new Set());
    const toggleAgentExpansion = (0, $cozmU.useCallback)((agentId)=>{
        setExpandedAgentIds((previous)=>{
            const next = new Set(previous);
            if (next.has(agentId)) next.delete(agentId);
            else next.add(agentId);
            return next;
        });
    }, []);
    return (0, $cozmU.useMemo)(()=>{
        const rows = [];
        parentRows.forEach((row)=>{
            const { isAgent: isAgent, isExpandable: isExpandable, agentId: agentId_0 } = row.data;
            if (isAgent && isExpandable && agentId_0) {
                const isExpanded = expandedAgentIds.has(agentId_0);
                rows.push({
                    ...row,
                    data: {
                        ...row.data,
                        isExpanded: isExpanded,
                        onToggleExpand: ()=>toggleAgentExpansion(agentId_0)
                    }
                });
                if (isExpanded) {
                    const children = childrenByAgentId[agentId_0] ?? [];
                    rows.push(...sorting ? [
                        ...children
                    ].sort((0, $hjyA9.sortByState)(sorting)) : children);
                }
            } else rows.push(row);
        });
        return rows;
    }, [
        parentRows,
        childrenByAgentId,
        expandedAgentIds,
        toggleAgentExpansion,
        sorting
    ]);
};
const $4580118d363597fd$export$24e644fa464a5e9f = (formatMessage, name, count)=>formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.agentSubtitle, {
        name: name,
        count: count
    });
function $4580118d363597fd$var$_temp() {
    return new Set();
}
module.exports["agentActivityI18n"] = $4580118d363597fd$export$8f1cb3c7f8edc6be;
module.exports["AgentRowAvatar"] = $4580118d363597fd$export$951877a280bbd2e;
module.exports["AgentUserDualAvatar"] = $4580118d363597fd$export$524e3ea25887b088;
module.exports["AgentChildRowIndent"] = $4580118d363597fd$export$bf2de6dc20683668;
module.exports["useExpandableAgentRows"] = $4580118d363597fd$export$3083e75456a22336;
module.exports["getAgentSubtitle"] = $4580118d363597fd$export$24e644fa464a5e9f;

});

parcelRegister("nRoEX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7akNQ = parcelRequire("7akNQ");


var $a6t12 = parcelRequire("a6t12");


var $9HYu9 = parcelRequire("9HYu9");

const $f1de479a2565efb2$export$a29b2672c127ab56 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { userId: userId, fullName: fullName, children: children, agent: agent, position: t1, offset: t2 } = t0;
    const position = t1 === undefined ? "bottom-start" : t1;
    let t3;
    if ($[0] !== t2) {
        t3 = t2 === undefined ? [
            0,
            8
        ] : t2;
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const offset = t3;
    let t4;
    if ($[2] !== userId) {
        t4 = (0, $9HYu9.toUsableIdentityAccountId)(userId);
        $[2] = userId;
        $[3] = t4;
    } else t4 = $[3];
    const usableUserId = t4;
    if (!usableUserId) {
        let t5;
        if ($[4] !== children) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[4] = children;
            $[5] = t5;
        } else t5 = $[5];
        return t5;
    }
    let t5;
    if ($[6] !== agent) {
        t5 = agent ? {
            agent: agent
        } : {};
        $[6] = agent;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== children || $[9] !== fullName || $[10] !== offset || $[11] !== position || $[12] !== t5 || $[13] !== usableUserId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: usableUserId,
            fullName: fullName,
            trigger: "click",
            position: position,
            offset: offset,
            ...t5
        }, children);
        $[8] = children;
        $[9] = fullName;
        $[10] = offset;
        $[11] = position;
        $[12] = t5;
        $[13] = usableUserId;
        $[14] = t6;
    } else t6 = $[14];
    const card = t6;
    if (agent) {
        let t7;
        if ($[15] !== card) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, card);
            $[15] = card;
            $[16] = t7;
        } else t7 = $[16];
        return t7;
    }
    return card;
} : ({ userId: userId, fullName: fullName, children: children, agent: agent, position: position = 'bottom-start', offset: offset = [
    0,
    8
] })=>{
    const usableUserId = (0, $9HYu9.toUsableIdentityAccountId)(userId);
    if (!usableUserId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: usableUserId,
        fullName: fullName,
        trigger: "click",
        position: position,
        offset: offset,
        ...agent ? {
            agent: agent
        } : {}
    }, children);
    if (agent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, card);
    return card;
};
module.exports["AnalyticsProfileIdentity"] = $f1de479a2565efb2$export$a29b2672c127ab56;

});

parcelRegister("9HYu9", function(module, exports) {

var $7MSLi = parcelRequire("7MSLi");

const $08f816fb1d0a7083$var$FALLBACK_KEY_PREFIX = '__fallback__:';
const $08f816fb1d0a7083$export$e66103ae8a5b999c = (value)=>{
    if (!value) return undefined;
    if (value === (0, $7MSLi.ANONYMOUS) || value === (0, $7MSLi.UNIDENTIFIED)) return undefined;
    if (value.startsWith('ari:') || value.startsWith($08f816fb1d0a7083$var$FALLBACK_KEY_PREFIX)) return undefined;
    return value;
};
const $08f816fb1d0a7083$export$293a6fca06c64633 = (records)=>{
    for (const record of records){
        const id = $08f816fb1d0a7083$export$e66103ae8a5b999c(record.userProfile?.id ?? record.accountId);
        if (id) return id;
    }
    return undefined;
};
module.exports["toUsableIdentityAccountId"] = $08f816fb1d0a7083$export$e66103ae8a5b999c;
module.exports["pickUsableAgentAccountId"] = $08f816fb1d0a7083$export$293a6fca06c64633;

});

parcelRegister("8sEcW", function(module, exports) {

let $629020abd28492c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $629020abd28492c2$var$load("3JFXu").then(()=>parcelRequire('6DKnm'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("iXwTo", function(module, exports) {

let $dcd7406fdbe381ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dcd7406fdbe381ac$var$load("8FO7k").then(()=>parcelRequire('68voD'));

});

parcelRegister("4gdcu", function(module, exports) {

let $31a2e56707b4dad0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31a2e56707b4dad0$var$load("2vGEp").then(()=>parcelRequire('4QNrJ'));

});

parcelRegister("24asi", function(module, exports) {

let $181410b6400a92c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $181410b6400a92c3$var$load("39gUe").then(()=>parcelRequire('cC6Gf'));

});

parcelRegister("30hRj", function(module, exports) {

let $22ff3999f5da2fe5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22ff3999f5da2fe5$var$load("iEop5").then(()=>parcelRequire('4x9Sq'));

});

parcelRegister("jwYVS", function(module, exports) {

let $e3804568fb1a70ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3804568fb1a70ba$var$load("dNCzW").then(()=>parcelRequire('fghXu'));

});

parcelRegister("3Jxmn", function(module, exports) {

let $2b7f73abbad84dca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b7f73abbad84dca$var$load("lQMKi").then(()=>parcelRequire('5dI20'));

});

parcelRegister("2fpBI", function(module, exports) {

let $1a30d893179acb96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1a30d893179acb96$var$load("7Zwkf").then(()=>parcelRequire('iOkOZ'));

});

parcelRegister("1np84", function(module, exports) {

let $100b6e922fa4b842$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $100b6e922fa4b842$var$load("emI6C").then(()=>parcelRequire('kldrI'));

});

parcelRegister("3uVyX", function(module, exports) {

let $28c0d33b89470db2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28c0d33b89470db2$var$load("1Tkkw").then(()=>parcelRequire('aDuQh'));

});

parcelRegister("coVO2", function(module, exports) {

let $90749106a8caa269$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90749106a8caa269$var$load("lGO8g").then(()=>parcelRequire('bITIM'));

});

parcelRegister("au1T9", function(module, exports) {

let $7a1e2bc58da25a52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a1e2bc58da25a52$var$load("1CZVz").then(()=>parcelRequire('9UBMU'));

});

parcelRegister("51PuZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $6mKj3 = parcelRequire("6mKj3");


var $9HYu9 = parcelRequire("9HYu9");

/**
 * Shared, query-agnostic classification core for AI-agent page views.
 *
 * Both the Page Analytics viewers table (`agentViewers.ts`) and the byline
 * analytics dialog (`usePageViews.ts`) read agent page views from
 * `ContentAnalyticsPageViewInfo` but shape them into different row models. The
 * *rules* for detecting agents, grouping their views, and resolving an agent's
 * display name + fallback icon are identical, so they live here as the single
 * source of truth.
 *
 * Agents carry no resolvable account id in the analytics data, so identity is
 * resolved entirely locally:
 *   - Source agents ("Atlassian MCP", "Teamwork Graph CLI") → treated as
 *     external/unidentified: folded into the "External agents" row + AI-agent icon.
 *   - Resolved (has `userProfile.displayName`) → that name, hexagon avatar,
 *     grouped by `displayName` (so the same agent under different account ids
 *     consolidates into one row).
 *   - Resolved to a known brand (Cursor, Claude, Claude Code, ChatGPT, Figma, Dia,
 *     Codex) → the brand name + brand icon, grouped by brand, so a product's
 *     per-integration accounts ("Claude Code (atlassian-mcp)", "…-2") read as one row.
 *   - Unresolved + `agentType === 'rovo_chat'` → "Rovo" + Rovo icon.
 *   - Unresolved (any other agentType) → "External agents" (aggregated) or
 *     "External agent" (a single agent attributed to a named person) + AI-agent icon.
 * Unresolved agents of the same type roll up into a single fallback row.
 */ const $67183ad6188fcf05$var$i18n = (0, $kSwu1.defineMessages)({
    unknownAgents: {
        id: "confluence-analytics.agent-classification.unknown-agents",
        defaultMessage: "External agents"
    },
    unknownAgent: {
        id: "confluence-analytics.agent-classification.unknown-agent",
        defaultMessage: "External agent"
    }
});
const $67183ad6188fcf05$export$eab4c408f5abf2ff = (formatMessage)=>formatMessage($67183ad6188fcf05$var$i18n.unknownAgent);
const $67183ad6188fcf05$export$c7c7160dc5a9d33a = 'rovo_chat';
const $67183ad6188fcf05$var$ATLASSIAN_MCP_AGENT_DISPLAY_NAME = 'Atlassian MCP';
const $67183ad6188fcf05$var$TEAMWORK_GRAPH_CLI_AGENT_DISPLAY_NAME = 'Teamwork Graph CLI';
const $67183ad6188fcf05$export$7af4520dc934019f = 'Cursor';
const $67183ad6188fcf05$export$d048749c292c39ba = 'Claude';
const $67183ad6188fcf05$export$7dc1083f44d74774 = 'Claude Code';
const $67183ad6188fcf05$export$31ec687fdc994f09 = 'ChatGPT';
const $67183ad6188fcf05$export$2ea0ce5717de8323 = 'Figma';
const $67183ad6188fcf05$export$6f59e6429875a6c1 = 'Dia';
const $67183ad6188fcf05$export$601e106de03de187 = 'Codex';
/** Group-key prefix for unresolved agents. */ const $67183ad6188fcf05$var$FALLBACK_KEY_PREFIX = '__fallback__:';
const $67183ad6188fcf05$export$4fcfd4291fd95196 = `${$67183ad6188fcf05$var$FALLBACK_KEY_PREFIX}${$67183ad6188fcf05$export$c7c7160dc5a9d33a}`;
const $67183ad6188fcf05$export$e3b8290e8c3dc86b = `${$67183ad6188fcf05$var$FALLBACK_KEY_PREFIX}unknown`;
const $67183ad6188fcf05$var$AGENT_NAME_GROK = 'Grok';
const $67183ad6188fcf05$var$AGENT_NAME_GITHUB_COPILOT = 'GitHub Copilot';
const $67183ad6188fcf05$var$AGENT_NAME_VISUAL_STUDIO_CODE = 'Visual Studio Code';
const $67183ad6188fcf05$var$AGENT_NAME_OPEN_CODE = 'Open Code';
const $67183ad6188fcf05$var$AGENT_NAME_HERMES_AGENT = 'Hermes Agent';
const $67183ad6188fcf05$var$AGENT_NAME_KIRO = 'Kiro';
const $67183ad6188fcf05$var$KNOWN_AGENT_TYPE_BRANDS = {
    claude: {
        name: $67183ad6188fcf05$export$d048749c292c39ba,
        agentIcon: 'claude',
        groupKey: $67183ad6188fcf05$export$d048749c292c39ba
    },
    codex: {
        name: $67183ad6188fcf05$export$601e106de03de187,
        agentIcon: 'codex',
        groupKey: $67183ad6188fcf05$export$601e106de03de187
    },
    cursor: {
        name: $67183ad6188fcf05$export$7af4520dc934019f,
        agentIcon: 'cursor',
        groupKey: $67183ad6188fcf05$export$7af4520dc934019f
    },
    chatgpt: {
        name: $67183ad6188fcf05$export$31ec687fdc994f09,
        agentIcon: 'chatgpt',
        groupKey: $67183ad6188fcf05$export$31ec687fdc994f09
    },
    dia: {
        name: $67183ad6188fcf05$export$6f59e6429875a6c1,
        agentIcon: 'dia',
        groupKey: $67183ad6188fcf05$export$6f59e6429875a6c1
    },
    grok: {
        name: $67183ad6188fcf05$var$AGENT_NAME_GROK,
        agentIcon: 'grok',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_GROK
    },
    github_copilot: {
        name: $67183ad6188fcf05$var$AGENT_NAME_GITHUB_COPILOT,
        agentIcon: 'github-copilot',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_GITHUB_COPILOT
    },
    vscode: {
        name: $67183ad6188fcf05$var$AGENT_NAME_VISUAL_STUDIO_CODE,
        agentIcon: 'vscode',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_VISUAL_STUDIO_CODE
    },
    open_code: {
        name: $67183ad6188fcf05$var$AGENT_NAME_OPEN_CODE,
        agentIcon: 'open-code',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_OPEN_CODE
    },
    hermes: {
        name: $67183ad6188fcf05$var$AGENT_NAME_HERMES_AGENT,
        agentIcon: 'hermes',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_HERMES_AGENT
    },
    kiro: {
        name: $67183ad6188fcf05$var$AGENT_NAME_KIRO,
        agentIcon: 'kiro',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_KIRO
    },
    [$67183ad6188fcf05$export$c7c7160dc5a9d33a]: {
        name: 'Rovo',
        agentIcon: 'rovo',
        groupKey: $67183ad6188fcf05$export$4fcfd4291fd95196
    }
};
const $67183ad6188fcf05$var$EXTERNAL_AGENT_TYPES = new Set([
    'twg',
    'mcp'
]);
const $67183ad6188fcf05$export$2cbed9b06ea7b2c1 = (pageView)=>pageView.accountType === 'AGENT' || pageView.agentType != null && pageView.agentType !== '';
const $67183ad6188fcf05$export$939c7376dc073a78 = (pageView)=>!!pageView.userProfile?.displayName;
const $67183ad6188fcf05$export$70ce5fa8ab74e3a = (record)=>{
    const relatedAccountId = record.relatedUserAccountId ?? record.relatedUser?.id;
    if (!relatedAccountId) return false;
    return relatedAccountId === record.userProfile?.id || relatedAccountId === record.accountId;
};
const $67183ad6188fcf05$export$5f3f502685876df = (agentType)=>{
    const normalized = agentType?.trim().toLowerCase();
    if (!normalized) return undefined;
    if ($67183ad6188fcf05$var$EXTERNAL_AGENT_TYPES.has(normalized)) return {
        kind: 'external'
    };
    const brand = $67183ad6188fcf05$var$KNOWN_AGENT_TYPE_BRANDS[normalized];
    if (brand) return {
        kind: 'brand',
        ...brand
    };
    return undefined;
};
/**
 * Source agents (e.g. Atlassian MCP, Teamwork Graph CLI) resolve to a display
 * name but represent activity from agents without a unique identifier, so they
 * are treated as external/unidentified rather than named agents.
 */ const $67183ad6188fcf05$var$isUnidentifiedSourceAgent = (pageView)=>pageView.userProfile?.displayName === $67183ad6188fcf05$var$ATLASSIAN_MCP_AGENT_DISPLAY_NAME || pageView.userProfile?.displayName === $67183ad6188fcf05$var$TEAMWORK_GRAPH_CLI_AGENT_DISPLAY_NAME;
/**
 * Known agent brands, each with the icon it renders in place of the account `picture`.
 * "Claude Code" is listed alongside "Claude" because it is the same brand under a
 * different product name, so both render the Claude icon while staying separate rows.
 */ const $67183ad6188fcf05$var$AGENT_BRANDS = [
    {
        name: $67183ad6188fcf05$export$7af4520dc934019f,
        agentIcon: 'cursor'
    },
    {
        name: $67183ad6188fcf05$export$7dc1083f44d74774,
        agentIcon: 'claude'
    },
    {
        name: $67183ad6188fcf05$export$d048749c292c39ba,
        agentIcon: 'claude'
    },
    {
        name: $67183ad6188fcf05$export$31ec687fdc994f09,
        agentIcon: 'chatgpt'
    },
    {
        name: $67183ad6188fcf05$export$2ea0ce5717de8323,
        agentIcon: 'figma'
    },
    {
        name: $67183ad6188fcf05$export$6f59e6429875a6c1,
        agentIcon: 'dia'
    },
    {
        name: $67183ad6188fcf05$export$601e106de03de187,
        agentIcon: 'codex'
    }
];
/**
 * The brand a resolved display name belongs to, or `undefined` for an agent that is not a
 * known brand (it keeps its own name + account `picture`/hexagon avatar).
 *
 * A name matches its brand either exactly or with the per-integration suffix some agents
 * carry — Claude Code registers one account per integration ("Claude Code
 * (atlassian-mcp)", "Claude Code (atlassian-mcp-2)"), and matching the `"<brand> ("`
 * prefix is what folds every one of those into a single brand row. The trailing `" ("` is
 * required so an unrelated agent that merely starts with a brand name (e.g. "Claudette")
 * is not mistaken for the brand.
 */ const $67183ad6188fcf05$var$getAgentBrand = (displayName)=>$67183ad6188fcf05$var$AGENT_BRANDS.find((brand)=>displayName === brand.name || displayName.startsWith(`${brand.name} (`));
const $67183ad6188fcf05$var$getProfileAvatarUrl = (userProfile)=>userProfile?.avatarUrl ?? userProfile?.photos?.find((photo)=>photo?.isPrimary)?.value ?? userProfile?.photos?.find(Boolean)?.value ?? undefined;
const $67183ad6188fcf05$export$f947ba472de8fa33 = (pageView)=>{
    const typeMapping = $67183ad6188fcf05$export$5f3f502685876df(pageView.agentType);
    if (typeMapping != null && (0, $6mKj3.expVal)('ai_analytics_agent_types', 'isEnabled', false)) return typeMapping.kind === 'external' ? $67183ad6188fcf05$export$e3b8290e8c3dc86b : typeMapping.groupKey;
    if ($67183ad6188fcf05$var$isUnidentifiedSourceAgent(pageView)) return $67183ad6188fcf05$export$e3b8290e8c3dc86b;
    if ($67183ad6188fcf05$export$939c7376dc073a78(pageView)) {
        const displayName = pageView.userProfile?.displayName ?? '';
        return $67183ad6188fcf05$var$getAgentBrand(displayName)?.name ?? displayName;
    }
    return pageView.agentType === $67183ad6188fcf05$export$c7c7160dc5a9d33a ? $67183ad6188fcf05$export$4fcfd4291fd95196 : $67183ad6188fcf05$export$e3b8290e8c3dc86b;
};
const $67183ad6188fcf05$export$ff6ff512b7960604 = (agentGroupKeyValue)=>agentGroupKeyValue === $67183ad6188fcf05$export$e3b8290e8c3dc86b;
const $67183ad6188fcf05$export$2d687ba75dd39eaa = (agentGroupKeyValue)=>agentGroupKeyValue === $67183ad6188fcf05$export$e3b8290e8c3dc86b;
const $67183ad6188fcf05$var$ROVO_FALLBACK_DISPLAY_NAME = 'Rovo';
const $67183ad6188fcf05$export$1f92ae96899118d1 = ({ accountId: accountId, agentIcon: agentIcon, groupKey: groupKey, displayName: displayName })=>{
    const isAriAccountId = Boolean(accountId?.startsWith('ari:'));
    if (!isAriAccountId && !(0, $9HYu9.toUsableIdentityAccountId)(accountId)) return false;
    if (agentIcon) return false;
    if (groupKey && ($67183ad6188fcf05$export$2d687ba75dd39eaa(groupKey) || groupKey === $67183ad6188fcf05$export$4fcfd4291fd95196)) return false;
    if (displayName && ($67183ad6188fcf05$var$getAgentBrand(displayName) || displayName === $67183ad6188fcf05$var$ROVO_FALLBACK_DISPLAY_NAME)) return false;
    return true;
};
const $67183ad6188fcf05$export$c9407f416ee8a7ec = (records, formatMessage)=>{
    const typeMapping = $67183ad6188fcf05$export$5f3f502685876df(records[0]?.agentType);
    if (typeMapping != null && (0, $6mKj3.expVal)('ai_analytics_agent_types', 'isEnabled', false)) {
        if (typeMapping.kind === 'external') return {
            name: formatMessage($67183ad6188fcf05$var$i18n.unknownAgents),
            agentIcon: 'ai-agent'
        };
        return {
            name: typeMapping.name,
            agentIcon: typeMapping.agentIcon
        };
    }
    const resolvedProfile = records.filter((record)=>!$67183ad6188fcf05$var$isUnidentifiedSourceAgent(record)).find((record)=>record.userProfile?.displayName)?.userProfile;
    if (records.some($67183ad6188fcf05$var$isUnidentifiedSourceAgent)) return {
        name: formatMessage($67183ad6188fcf05$var$i18n.unknownAgents),
        agentIcon: 'ai-agent'
    };
    if (resolvedProfile?.displayName) {
        // The Cursor/Claude/Claude Code/ChatGPT/Figma/Dia/Codex agents resolve to a real
        // account, but we show the brand name + brand icon rather than the account's own name
        // and `picture`, so per-integration variants (e.g. "Claude Code (atlassian-mcp)") read
        // as the single product row they are grouped into by `agentGroupKey`.
        const brand = $67183ad6188fcf05$var$getAgentBrand(resolvedProfile.displayName);
        if (brand) return {
            name: brand.name,
            agentIcon: brand.agentIcon
        };
        return {
            name: resolvedProfile.displayName,
            avatarUrl: $67183ad6188fcf05$var$getProfileAvatarUrl(resolvedProfile)
        };
    }
    if (records[0]?.agentType === $67183ad6188fcf05$export$c7c7160dc5a9d33a) return {
        name: 'Rovo',
        agentIcon: 'rovo'
    };
    return {
        name: formatMessage($67183ad6188fcf05$var$i18n.unknownAgents),
        agentIcon: 'ai-agent'
    };
};
module.exports["getUnknownAgentSingularName"] = $67183ad6188fcf05$export$eab4c408f5abf2ff;
module.exports["AGENT_TYPE_ROVO_CHAT"] = $67183ad6188fcf05$export$c7c7160dc5a9d33a;
module.exports["isAgentPageView"] = $67183ad6188fcf05$export$2cbed9b06ea7b2c1;
module.exports["isSelfAttributedAgentRecord"] = $67183ad6188fcf05$export$70ce5fa8ab74e3a;
module.exports["getAgentTypeMapping"] = $67183ad6188fcf05$export$5f3f502685876df;
module.exports["agentGroupKey"] = $67183ad6188fcf05$export$f947ba472de8fa33;
module.exports["isUnknownAgentGroupKey"] = $67183ad6188fcf05$export$ff6ff512b7960604;
module.exports["isUnidentifiedAgentGroupKey"] = $67183ad6188fcf05$export$2d687ba75dd39eaa;
module.exports["isClickableAgentIdentity"] = $67183ad6188fcf05$export$1f92ae96899118d1;
module.exports["resolveAgentNameAndIcon"] = $67183ad6188fcf05$export$c9407f416ee8a7ec;

});


//# sourceMappingURL=AnalyticsByLine.7cc61e66.js.map
